// Default theme colors
export const CoreColors = {
  appBlack: '#252424',
  appBlackAlpha10: '#e8e7e6',
  appWhite: '#fff',
  appWhiteAlpha10: 'rgba(255, 255, 255, 0.1)',
  appBrand02: '#33344a',
  appBrand04: '#464775',
  appBrand06: '#6264a7',
  appBrand08: '#8b8cc7',
  appBrand12: '#bdbde6',
  appBrand14: '#e2e2f6',
  appBrand16: '#f4f4fc',
  appBrand00: '#6264a7', // Does not swap in dark theme
  appGray02: '#484644',
  appGray03: '#605e5c',
  appGray04: '#979593',
  appGray06: '#c8c6c4',
  appGray08: '#e1dfdd',
  appGray09: '#edebe9',
  appGray10: '#f3f2f1',
  appGray12: 'rgba(37, 36, 35, 0.05)',
  appGray14: '#faf9f8',
  appMagenta: '#b24782',
  appOrchid: '#943670',
  appRed: '#c4314b',
  appRed08: '#f3d6d8',
  appRed10: '#fcf4f6',
  appYellow: '#f8d22a',
  overlayBackground: 'rgba(37, 36, 35, 0.75)'
};

// Dark theme colors
export const DarkColors = {
  appBlack: '#fff',
  appBlackAlpha10: 'rgba(255, 255, 255, 0.1)',
  appWhite: '#201f1f',
  appWhiteAlpha10: 'rgba(255, 255, 255, 0.1)',
  appBrand02: '#e2e3f6',
  appBrand04: '#bdbde6',
  appBrand06: '#a6a7dc',
  appBrand08: '#8b8cc7',
  appBrand12: '#6264a7',
  appBrand14: '#464775',
  appBrand16: '#33344a',
  appGray02: '#c8c6c4',
  appGray03: '#b3b0ad',
  appGray04: '#8a8886',
  appGray06: '#605e5c',
  appGray08: '#484644',
  appGray09: '#3b3a3a',
  appGray10: '#2d2c2c',
  appGray12: 'rgba(255, 255, 255, 0.05)',
  appGray14: '#292828',
  appMagenta: '#cf6098',
  appOrchid: '#ae3d84',
  appRed: '#d74553',
  appRed08: '#4f222b',
  appRed10: '#1e060c',
  appYellow: '#f8d229',
  overlayBackground: 'rgba(37,36,35,.75)'
};

// Contrast theme colors
export const ContrastColors = {
  appBlack: '#fff',
  appBlackAlpha10: 'rgba(255, 255, 255, 0.1)',
  appWhite: '#000',
  appWhiteAlpha10: 'rgba(255, 255, 255, 0.1)',

  appBrand02: '#000',
  appBrand04: '#ffff00',
  appBrand06: '#00ebff',
  appBrand08: '#ffff00',
  appBrand12: '#ffff00',
  appBrand14: '#000',
  appBrand16: '#000',

  appGray02: '#fff',
  appGray03: '#000',
  appGray04: '#fff',
  appGray06: '#000',
  appGray08: '#fff',
  appGray09: '#000',
  appGray10: '#000',
  appGray12: '#fff',
  appGray14: '#000',

  appGreenContrast: '#30f42c',

  overlayBackground: 'rgba(0,0,0,.75)',

  appRed: '#fff',
  appRed08: '#fff',
  appRed10: '#fff'
};

export const SecondaryColors = {
  appOrange01: '#833122',
  appOrange02: '#a33d2a',
  appOrange03: '#bd432c',
  appOrange04: '#cc4a31',
  appOrange: '#e97548',
  appOrange14: '#efdbd3',
  appOrange16: '#f9ecea',
  appGreen: '#92c353',
  appGreen04: '#237b4b'
};

export const BoxShadowColors = {
  boxShadowColor: 'rgba(0,0,0,.1)',
  boxShadowColorDark: 'rgba(0,0,0,.25)',
  boxShadowColorDarker: 'rgba(0,0,0,.5)'
};

export const appWhiteAlpha10 = 'rgba(37, 36, 36, 0.1)';
